function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React from "react";
export default (({
  styles = {},
  ...props
}) => React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  width: "72",
  height: "68",
  fill: "none"
}, props), React.createElement("path", {
  fill: "url(#svg3525966134__paint0_linear)",
  fillRule: "evenodd",
  d: "M56.464 47.162l.536-.845-.535.845.002.002.004.002.012.008a1.5 1.5 0 00.038.023c.032.019.075.045.13.075.107.061.259.142.441.228a5.36 5.36 0 001.431.46c.548.083 1.292.073 1.934-.396.665-.485.98-1.282 1.04-2.237l.002-.032.001-7.32C67.757 34.693 72 27.773 72 19.964 72 8.993 63.58 0 53.08 0H38.92C28.42 0 20 8.993 20 19.963V20h-1.029C8.451 20 0 28.914 0 39.811c0 7.762 4.282 14.503 10.546 17.75l-.016 7.495.002.033c.059.908.3 1.653.783 2.18.502.549 1.136.721 1.673.73.515.01.98-.128 1.286-.243a4.333 4.333 0 00.539-.248l.012-.007.005-.003.002-.001.052-.03 10.432-7.844h7.844c9.236 0 16.882-6.876 18.6-15.928l4.675 3.448.029.019zM22 19.963C22 9.99 29.629 2 38.92 2h14.16C62.37 2 70 9.99 70 19.963c0 7.31-4.092 13.688-9.933 16.495l-.567.272v8.5c-.043.589-.21.71-.222.719-.033.024-.15.08-.452.034a3.386 3.386 0 01-.881-.292 4.844 4.844 0 01-.386-.204l-10.23-7.547H38.92C29.63 37.94 22 29.938 22 19.963zm27.952 22.398l-3.281-2.42h-7.75c-9.845 0-17.858-7.915-18.823-17.941H18.97C9.641 22 2 29.932 2 39.811c0 7.233 4.108 13.438 9.977 16.228l.572.272-.019 8.681c.045.63.2.86.26.926.042.046.095.08.232.082.16.003.357-.044.544-.115.088-.033.16-.066.208-.09l.015-.008 10.86-8.164h8.511c8.512 0 15.616-6.6 16.792-15.262z",
  clipRule: "evenodd"
}), React.createElement("path", {
  fill: "#80C",
  fillRule: "evenodd",
  d: "M35 11a1 1 0 011-1h.77a1 1 0 110 2H36a1 1 0 01-1-1zm4 0a1 1 0 011-1h18a1 1 0 110 2H40a1 1 0 01-1-1zm-4 8a1 1 0 011-1h22a1 1 0 110 2H36a1 1 0 01-1-1zm0 8a1 1 0 011-1h11.77a1 1 0 110 2H36a1 1 0 01-1-1zm16 0a1 1 0 011-1h.77a1 1 0 110 2H52a1 1 0 01-1-1z",
  clipRule: "evenodd"
}), React.createElement("defs", null, React.createElement("linearGradient", {
  id: "svg3525966134__paint0_linear",
  x1: "36",
  x2: "36",
  y1: "0",
  y2: "68",
  gradientUnits: "userSpaceOnUse"
}, React.createElement("stop", {
  stopColor: "#A0F"
}), React.createElement("stop", {
  offset: "1",
  stopColor: "#00A3D7"
})))));